import { render, staticRenderFns } from "./TotalAnalogCloseRatioCard.vue?vue&type=template&id=310b0bac&scoped=true&"
import script from "./TotalAnalogCloseRatioCard.vue?vue&type=script&lang=js&"
export * from "./TotalAnalogCloseRatioCard.vue?vue&type=script&lang=js&"
import style0 from "./TotalAnalogCloseRatioCard.vue?vue&type=style&index=0&id=310b0bac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310b0bac",
  null
  
)

export default component.exports